/* eslint-disable operator-linebreak */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { InitialIcon } from '../../../../redux/helper/IconGenerator';
import { InitialMaker } from '../../../../redux/helper/InitialMaker';

function ListASE(props) {
    const { OrderDetails } = props;
    return (
        <div className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] h-auto p-3 my-4 assigned1">
            <p className="font-semibold text-base text-[#090406] assigned">Assigned ASE(s)</p>

            {OrderDetails?.ASEs?.map((item, index) => (
                item ? (
                    <div key={index} className="flex mt-3">
                        {/* <img src="/images/Profile6.png" alt="icon" className="w-[26px] h-[26px]" /> */}
                        <InitialIcon
                            initials={InitialMaker(
                                item?.FIRST_NAME || item?.first_name || '',
                                item?.LAST_NAME || item?.last_name || '',
                            )}
                            widthValue="26"
                            heightValue="26"
                            font="15"
                        />
                        <div className="pl-2">
                            <p className="text-lg font-normal text-[#303030]">
                                {item?.FIRST_NAME || item?.first_name}
                                {' '}
                                {item?.LAST_NAME || item?.last_name}
                            </p>
                            <p className="text-xs12 font-semibold text-[#707070]">
                                <span>{item?.employee_code}</span>
                                <span className="pl-1.5">
                                    {item?.PRODUCT_CATEGORIES?.length > 0 &&
                                        item.PRODUCT_CATEGORIES.map((val, i) => (
                                            <span key={i}>{val}</span>
                                        ))}
                                </span>
                            </p>
                        </div>
                    </div>
                ) : null
            ))}

        </div>
    );
}

export default ListASE;
